// Abbreviate large stats with at most one decimal place, dropping a trailing
// ".0" (e.g. 1_500 -> "1.5K", 2_000_000 -> "2M", 3_200_000_000 -> "3.2B").
// Shared by the LISWP hero blocks so the Views/Downloads stats read identically
// across page variants.
export function formatStat(count: number): string {
  const tiers = [
    { threshold: 1e9, suffix: 'B' },
    { threshold: 1e6, suffix: 'M' },
    { threshold: 1e3, suffix: 'K' },
  ];
  const tier = tiers.find(({ threshold }) => count >= threshold);
  if (!tier) {
    return String(count);
  }
  const scaled = (count / tier.threshold).toFixed(1).replace(/\.0$/, '');
  return `${scaled}${tier.suffix}`;
}
